
export interface HotelToursSearchRequest {
  params: HotelToursSearchParams;
}

export interface HotelToursSearchResponse {
  error?: string;
  id: string;
  timeout: number;
}

export interface HotelToursSearchParams {
  adults: number;
  airlines?: string[];
  childAges?: number[];
  countryId: number;
  dateFrom: string;
  dateTo: string;
  departCityId?: number;
  hotelsSearch?: number | boolean;
  meals?: string[];
  nightsFrom: number;
  nightsTo: number;
  daysFrom: number;
  daysTo: number;
  splitRooms?: boolean;
  forceDates?: number;
  from?: string;
}

export interface HotelToursSearchResult {
  error?: string;
  searchIsDone: boolean;
  tours: HotelToursResultTour[];
}

export interface HotelToursResultTour {
  id: string;
  hash?: string;
  dateFrom: string;
  dateTo: string;
  meal: HotelToursResultTourMeal;
  nights: number;
  nightsOnWay?: number;
  price: HotelToursResultTourPrice;
  rooms: HotelToursResultTourRoom[];
  flights?: HotelToursResultTourFlights;
  discount?: number;
  isBestPrice?: boolean;
  instantConfirm: boolean;
  hasSurcharges: boolean;
}

export interface HotelToursResultTourPrice {
  value: number;
  currency: string;
}

export interface HotelToursResultTourMeal {
  name: string;
}

export interface HotelToursResultTourRoom {
  name: string;
}

export interface HotelToursResultTourFlights {
  airlines: HotelToursResultTourAirline[];
  seats: HotelToursResultTourSeats[]
}

export interface HotelStaySearchResponse {
  error?: string;
  id: string;
  timeout: number;
}

export interface HotelStaySearchResult {
  error?: string;
  searchIsDone: boolean;
  tours: HotelStayResultTour[];
}

export interface HotelStayResultTour {
  id: string;
  dateFrom: string;
  dateTo: string;
  meal: HotelToursResultTourMeal;
  nights: number;
  price: HotelToursResultTourPrice;
  rooms: HotelToursResultTourRoom[];
  instantConfirm: boolean;
  hasSurcharges: boolean;
}

export interface HotelToursResultTourSeats {
  class: HotelToursResultResponseClassAvailable;
  availability: HotelToursResultTourAvailabilitySeats;
}

export interface HotelToursResultTourAvailabilitySeats {
  forward: HotelToursResultResponseSeatAvailable;
  backward: HotelToursResultResponseSeatAvailable;
}

export enum HotelToursResultResponseSeatAvailable {
  yes = 'Y',
  no = 'N',
  few = 'F',
  request = 'R',
}

export enum HotelToursResultResponseClassAvailable {
  economy = 'economy',
  business = 'business',
  premium = 'premium',
  comfort = 'comfort',
}

export interface HotelToursResultTourAirline {
  code: string;
  name: string;
  hasIcon: boolean;
}

export interface HotelToursFilterParams {
  filters: {
    airlines?: string[],
    mealIds?: string[],
  };
}

export interface HotelToursFiltersResult {
  filters: HotelToursResultFilters[];
}

export interface HotelToursResultFilters {
  name: string;
  filterKey: string;
  values: HotelToursResultFilterValues[];
}

export interface HotelToursResultFilterValues {
  filterValue: string;
  viewValue: string;
  count: number;
  minPrice: number;
  currency: string;
}

export interface HotelToursCalendarRequest {
  params: HotelToursCalendarParams
}

export interface HotelToursCalendarParams {
  adults: number;
  childAges?: number[];
  departCityId: number;
  countryId: number;
  regionsIds?: number[];
  hotelsIds?: number[];
  stars?: number[];
  dateFrom: string;
  dateTo: string;
  nightsFrom: number;
  nightsTo: number;
  currency?: string;
  airlines?: string[];
}

export interface HotelToursCalendarResponse {
  calendar: HotelToursCalendarRow[]
}
export interface HotelToursCalendarRow {
  nights: number,
  prices: HotelToursCalendarCell[],
}

export interface HotelToursCalendarCell {
  date: string,
  nights: number,
  price: {
    currency: string,
    value: number,
  },
  isBest: boolean,
  tourId: string,
}
